function print_card(card){
    let iframe=document.getElementById("print-iframe");
    if(!iframe){  
		iframe = document.createElement('IFRAME');
		iframe.setAttribute("id", "print-iframe");
		iframe.setAttribute('style', 'position:fixed;width:0px;height:0px;left:-500px;top:-500px;');
    	document.body.appendChild(iframe);
    }
	iframe.contentWindow.document.body.innerHTML=`
		<div class="box">
			<div class="card">${card}</div>
		</div>
		<style>
			.box{
				position:fixed;
				top:0;
				left:0;
				width:86mm;
				height:54mm;
			}
			.box .card{
				position:absolute;
				width:48mm;
				height:9mm;
				line-height:9mm;
				top:26mm;
				left: 22mm;
				font-size:24px;
				text-align:center;
				font-weight: bold;
			}
			 
		</style>
	`
	 
	iframe.contentWindow.print();
}

export default print_card;